module.exports = __webpack_public_path__ + "img/land-rover.40460045.jpg";